<template>
    <main id="main" class="--not-found">
        <Transition name="fade">
            <Loader v-if="!$page"/>
        </Transition>
        <template v-if="$page">
            <HeaderCTASection :content="$page.header"/>
        </template>
    </main>
</template>

<script>
import {HeaderCTASection} from '@/components/sections'
import {Loader} from '@/components/small'

export default {
    name: 'NotFound',
    beetPage: 'not_found',
    components: {
        HeaderCTASection,
        Loader
    }
}
</script>
